import { Vote } from "../../functions/src/schema";
const humanizeString = require("string-humanize");

export function formatVote(vote: Vote) {
  if (!vote) return "no vote";
  return humanizeString(vote);
}
